import { createSelector } from "@reduxjs/toolkit";

import type { BookmarkItem } from "domains/bookmarks/types";
import { createClusterSelector } from "domains/clusters/selectors";
import { getKnowledgeById } from "entities/knowledge/selectors";
import type { RootState } from "types";

const createBookmarkSelector = (item: BookmarkItem) =>
  item.type === "article" ? getKnowledgeById(item.id) : createClusterSelector(item.id);

export const createBookmarksSelector = (items: BookmarkItem[]) =>
  createSelector(...items.map(createBookmarkSelector), (...bookmarks) =>
    bookmarks.filter((item) => item !== undefined),
  );

export const getBookmarkOffset = (state: RootState) => state.domains.bookmarks.offset;

export const getBookmarkIsPending = (state: RootState) => state.domains.bookmarks.isPending;

export const getBookmarkHasNextPage = (state: RootState) => state.domains.bookmarks.hasNextPage;

export const getBookmarksItems = (state: RootState) => state.domains.bookmarks.items;

export const getBookmarkById = (id: string | undefined) => (state: RootState) => {
  if (id === undefined) return undefined;
  const bookmark = state.domains.bookmarks.items.find((item) => item.id === id);
  if (bookmark === undefined) return undefined;
  return createBookmarkSelector(bookmark)(state);
};
